import Icon from '../components/Icon.vue'

Icon.register({
  university: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 128v16c0 4.4-3.6 8-8 8h-24v12c0 6.6-5.4 12-12 12h-392c-6.6 0-12-5.4-12-12v-12h-24c-4.4 0-8-3.6-8-8v-16c0-3 2.2-6.3 4.9-7.4l232-88c0.8-0.3 2.2-0.6 3.1-0.6s2.2 0.3 3.1 0.6l232 88c2.7 1.1 4.9 4.4 4.9 7.4zM472 432c13.3 0 24 10.7 24 24v16c0 4.4-3.6 8-8 8h-464c-4.4 0-8-3.6-8-8v-16c0-13.3 10.7-24 24-24h432zM96 192h64v192h64v-192h64v192h64v-192h64v192h36c6.6 0 12 5.4 12 12v20h-416v-20c0-6.6 5.4-12 12-12h36v-192z'
      }
    ]
  }
})
